/* import __COLOCATED_TEMPLATE__ from './sync-status-filter.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { action } from '@ember/object';
import { SyncStatus } from 'embercom/models/knowledge-hub/sync-source-wrapper';

interface Args {
  doSearch: (syncStatus?: string) => void;
  selectedSyncStatusValue: string | null | undefined;
  activeFilter?: string;
  removeFilter: (syncStatus?: string) => void;
}

export default class SyncStatusFilter extends Component<Args> {
  @service declare intl: IntlService;

  get isOpen() {
    return this.args.activeFilter === 'syncStatus' && !this.args.selectedSyncStatusValue;
  }

  get syncStatuses() {
    return [
      {
        text: this.intl.t('knowledge-hub.filterable-list.filters.sync-status.live'),
        value: SyncStatus.LIVE,
      },
      {
        text: this.intl.t('knowledge-hub.filterable-list.filters.sync-status.syncing'),
        value: SyncStatus.SYNCING,
      },
      {
        text: this.intl.t('knowledge-hub.filterable-list.filters.sync-status.synced'),
        value: SyncStatus.SYNCED,
      },
      {
        text: this.intl.t('knowledge-hub.filterable-list.filters.sync-status.error'),
        value: SyncStatus.ERROR,
      },
    ];
  }

  get selectedSyncStatus() {
    let syncStatus = this.syncStatuses.find(
      (status) => status.value === this.args.selectedSyncStatusValue,
    );
    return !syncStatus || !syncStatus.value
      ? this.intl.t('knowledge-hub.filterable-list.filters.sync-status.status')
      : this.intl.t('knowledge-hub.filterable-list.filters.sync-status.sync-status-is', {
          syncStatus: syncStatus.text,
        });
  }

  @action removeFilter() {
    this.args.doSearch();
    this.args.removeFilter();
  }

  @action onSelectItem(selectedValue: string) {
    if (this.args.selectedSyncStatusValue === selectedValue) {
      // If the same value is clicked again, deselect it
      this.args.doSearch();
    } else {
      // Select the new value
      this.args.doSearch(selectedValue);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Filters::SyncStatusFilter': typeof SyncStatusFilter;
    'knowledge-hub/filterable-list/filters/sync-status-filter': typeof SyncStatusFilter;
  }
}
